<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 30.385 30">
        <g id="Group_2821" data-name="Group 2821" transform="translate(-24 -345)">
            <circle id="Ellipse_183" data-name="Ellipse 183" cx="14" cy="14" r="14" transform="translate(24 345)"
                    fill="#cedbff"/>
            <g id="contact_1_" data-name="contact (1)" transform="translate(32.464 340.435)">
                <g id="Group_2674" data-name="Group 2674" transform="translate(0.001 12.813)">
                    <g id="Group_2673" data-name="Group 2673" transform="translate(0 0)">
                        <path id="Path_70019" data-name="Path 70019"
                              d="M20.989,12.813H5.678a.954.954,0,0,0-.932.973V18.2l-.7-1.1a1.055,1.055,0,0,0-1.462-.344l-1.44.9A2.2,2.2,0,0,0,.178,18.97c-.525,2-.136,5.442,4.7,10.5,3.848,4.015,6.717,5.1,8.694,5.1a4.9,4.9,0,0,0,1.356-.185,2.132,2.132,0,0,0,1.253-1.007l.865-1.506a1.162,1.162,0,0,0-.329-1.525l-3.449-2.4a1.058,1.058,0,0,0-1.457.247l-1,1.349a.34.34,0,0,1-.447.1l-.191-.11a11.553,11.553,0,0,1-2.992-2.455c-.171-.179-.326-.346-.471-.506H20.989a.952.952,0,0,0,.932-.969V13.786A.954.954,0,0,0,20.989,12.813ZM9.821,30.194l.186.107a1.047,1.047,0,0,0,1.379-.3l1-1.349a.345.345,0,0,1,.475-.081l3.449,2.4a.379.379,0,0,1,.107.5l-.865,1.506a1.4,1.4,0,0,1-.819.664c-1.727.5-4.75.076-9.339-4.717S.41,20.975.884,19.172a1.443,1.443,0,0,1,.635-.855l1.442-.9a.344.344,0,0,1,.475.112l2.3,3.6a.382.382,0,0,1-.077.5L4.369,22.673a1.157,1.157,0,0,0-.284,1.441l.1.194a12.617,12.617,0,0,0,2.475,3.3A12.206,12.206,0,0,0,9.821,30.194Zm11.369-4.6a.2.2,0,0,1-.2.206H6.048a9.654,9.654,0,0,1-1.219-1.857l-.105-.2a.375.375,0,0,1,.094-.466l1.291-1.049A1.171,1.171,0,0,0,6.345,20.7l-.868-1.361V13.786a.213.213,0,0,1,.058-.149.194.194,0,0,1,.143-.061H20.989a.194.194,0,0,1,.143.061.213.213,0,0,1,.058.149V25.594Z"
                              transform="translate(-0.001 -12.813)" fill="#799cfb"/>
                        <path id="Path_70020" data-name="Path 70020"
                              d="M162.289,50.665l-6.38,4.838a.515.515,0,0,1-.605,0l-6.377-4.838a.382.382,0,0,0-.461.608l6.378,4.838a1.285,1.285,0,0,0,1.527,0l6.38-4.838a.382.382,0,0,0-.461-.608Z"
                              transform="translate(-142.657 -48.898)" fill="#799cfb"/>
                        <path id="Path_70021" data-name="Path 70021"
                              d="M152.823,172.517l-3.91,4.188a.382.382,0,0,0,.558.521l3.91-4.189a.382.382,0,0,0-.559-.519Z"
                              transform="translate(-142.51 -165.272)" fill="#799cfb"/>
                        <path id="Path_70022" data-name="Path 70022"
                              d="M370.612,172.2a.382.382,0,0,0-.558.521l3.909,4.188a.382.382,0,0,0,.558-.521Z"
                              transform="translate(-354.38 -164.954)" fill="#799cfb"/>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "IContactUs",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
